import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {SimulationListComponent} from './components/simulation-list/simulation-list.component';
import {AppComponent} from './components/app-component/app.component';
import {ManagementComponent} from './components/management/management.component';
import {SourcesComponent} from './components/sources/sources.component';
import {MainComponent} from './components/main/main.component';
import {SimulationTableFilterPipe} from './pipes/simulation-table-filter.pipe';
import {NewSimulationComponent, SimulationSavedComponent} from './components/new-simulation/new-simulation.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {routing} from './app.routes';
import {ProductInformationComponent} from './components/new-simulation/product-information/product-information.component';
import {MeaSelectionComponent} from './components/new-simulation/mea-selection/mea-selection.component';
import {TenderSelectionComponent} from './components/new-simulation/tender-selection/tender-selection.component';
import {SimulationInputComponent} from './components/new-simulation/simulation-input/simulation-input.component';
import {TenderSimulationInputComponent} from './components/new-simulation/tender-simulation-input/tender-simulation-input.component';
import {SimulationResultComponent} from './components/new-simulation/simulation-result/simulation-result.component';
import {TenderSimulationResultComponent} from './components/new-simulation/tender-simulation-result/tender-simulation-result.component';
import {HttpClientService} from './services/http-client.service';
import {MatCheckboxModule, MatDialogModule, MatProgressSpinnerModule} from '@angular/material';
import {MyDateRangePickerModule} from 'mydaterangepicker';
import {SavedSimulationComponent} from './components/saved-simulation/saved-simulation.component';
import {AuthService} from './services/auth.service';
import {SimulationsService} from './components/simulation-list/simulations.service';
import {SimulationComponent} from './components/simulation/simulation.component';
import {NewSimulationService} from './components/new-simulation/new-simulation.service';
import {SolutionsEditTableComponent} from './dialogs/solutions-edit-table/solutions-edit-table.component';
import {SimpleBarChartComponent} from './components/charts/simple-bar-chart/simple-bar-chart.component';
import {CurrencyTransformPipe} from './pipes/currency-transform.pipe';
import {DecimalPipe} from '@angular/common';
import {PeriodBarChartComponent} from './components/charts/period-bar-chart/period-bar-chart.component';
import {PieChartComponent} from './components/charts/pie-chart/pie-chart.component';
import {EditSimulationComponent} from './components/edit-simulation/edit-simulation.component';
import {Ng2SmartTableModule} from "ng2-smart-table";
import {ErrorDialogComponent} from "./dialogs/error-dialog/error-dialog.component";

@NgModule({
    declarations: [
        AppComponent,
        ManagementComponent,
        SimulationListComponent,
        SourcesComponent,
        MainComponent,
        SimulationTableFilterPipe,
        NewSimulationComponent,
        ProductInformationComponent,
        MeaSelectionComponent,
        TenderSelectionComponent,
        SimulationInputComponent,
        TenderSimulationInputComponent,
        SimulationResultComponent,
        TenderSimulationResultComponent,
        SavedSimulationComponent,
        SimulationComponent,
        SimulationSavedComponent,
        SolutionsEditTableComponent,
        SimpleBarChartComponent,
        CurrencyTransformPipe,
        PeriodBarChartComponent,
        PieChartComponent,
        EditSimulationComponent,
        ErrorDialogComponent
    ],
    imports: [
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        HttpModule,
        BrowserAnimationsModule,
        routing,
        BrowserAnimationsModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        MatCheckboxModule,
        MyDateRangePickerModule,
        Ng2SmartTableModule
    ],
    providers: [
        HttpClientService,
        AuthService,
        SimulationsService,
        NewSimulationService,
        DecimalPipe
    ],
    entryComponents: [
        SimulationSavedComponent,
        SolutionsEditTableComponent,
        ErrorDialogComponent
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/app.module.ts